import { useDark, useToggle, useColorMode } from '@vueuse/core'
import { useQuasar } from 'quasar'

export function useDarkMode() {
  const $q = useQuasar()

  const isDark = useDark({
    ...useColorMode(),
    valueDark: 'dark',
    valueLight: 'light',
    onChanged: $q.dark.set,
  })

  const toggleDark = useToggle(isDark)

  const initDarkMode = () => {
    // const darkMode = localStorage.getItem('vueuse-color-scheme')
    // if (darkMode !== 'light') {
    //   isDark.value = true
    //   $q.dark.set(true)
    // } else {
    //   isDark.value = false
    //   $q.dark.set(false)
    // }

    // Force dark mode at the moment
    isDark.value = true
    $q.dark.set(true)
  }

  return {
    isDark,
    toggleDark,
    initDarkMode,
  }
}
